import moment from 'moment';

export * from './fetch-wrapper';
export * from './history';

export const getUserTimeZone = () => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return userTimeZone
}
export const getAllMonths = () => {
  let currentMonth = moment();


  const upcomingMonths = [];


  for (let i = 0; i < 12; i++) {
    console.log(currentMonth.year(), "currentMonth", moment().year());
    if (moment().year() === currentMonth.year()) {
      upcomingMonths.push(currentMonth.format('MMMM YYYY'));
      currentMonth.add(1, 'month');
    }

  }

  return upcomingMonths;
}
